/* eslint-disable object-shorthand */
import axios from 'axios'

import config from '../../config'
import action, { actionFailed } from '../../util/action'
import createAsyncConst from '../../util/createAsyncConst'

export const RESET_PASSWORD = createAsyncConst('RESET_PASSWORD')

export function resetPassword(form) {
  return dispatch => {
    dispatch(action(RESET_PASSWORD.ACTION))
    return axios
      .post(`${config.API_URL}/user-reset-password`, form)
      .then(resp => {
        dispatch(action(RESET_PASSWORD.SUCCESS, resp?.data))
        return true
      })
      .catch(e => {
        dispatch(actionFailed(RESET_PASSWORD, e))
        return false
      })
  }
}
